<template>
  <v-container
    class="pa-0"
  >
    <div>
      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-badge
            :content="contentBadge"
            :value="showBadge"
            color="error"
            overlap
            left
            offset-x="11"
            offset-y="6"
          >
            <v-btn
              v-bind="attrs"
              icon
              small
              v-on="on"
              @click="openDialogButton"
              style="width: auto;height: auto;"
            >
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.9419 12.0581L16.25 10.3662V8.125C16.2481 6.57615 15.6719 5.08303 14.6329 3.93436C13.5939 2.7857 12.1659 2.06308 10.625 1.90625V0.625H9.375V1.90625C7.83411 2.06308 6.4061 2.7857 5.36711 3.93436C4.32811 5.08303 3.75194 6.57615 3.75 8.125V10.3662L2.05812 12.0581C1.94091 12.1753 1.87504 12.3343 1.875 12.5V14.375C1.875 14.5408 1.94085 14.6997 2.05806 14.8169C2.17527 14.9342 2.33424 15 2.5 15H6.875V15.4856C6.86113 16.2786 7.1405 17.0488 7.65954 17.6484C8.17858 18.2481 8.90073 18.635 9.6875 18.735C10.122 18.7781 10.5607 18.7298 10.9754 18.5931C11.3901 18.4565 11.7716 18.2346 12.0953 17.9416C12.4191 17.6487 12.678 17.2913 12.8553 16.8923C13.0326 16.4933 13.1245 16.0616 13.125 15.625V15H17.5C17.6658 15 17.8247 14.9342 17.9419 14.8169C18.0592 14.6997 18.125 14.5408 18.125 14.375V12.5C18.125 12.3343 18.0591 12.1753 17.9419 12.0581ZM11.875 15.625C11.875 16.1223 11.6775 16.5992 11.3258 16.9508C10.9742 17.3025 10.4973 17.5 10 17.5C9.50272 17.5 9.02581 17.3025 8.67417 16.9508C8.32254 16.5992 8.125 16.1223 8.125 15.625V15H11.875V15.625ZM16.875 13.75H3.125V12.7587L4.81687 11.0669C4.93409 10.9497 4.99996 10.7907 5 10.625V8.125C5 6.79892 5.52678 5.52715 6.46447 4.58947C7.40215 3.65178 8.67392 3.125 10 3.125C11.3261 3.125 12.5979 3.65178 13.5355 4.58947C14.4732 5.52715 15 6.79892 15 8.125V10.625C15 10.7907 15.0659 10.9497 15.1831 11.0669L16.875 12.7587V13.75Z" fill="#030303"/>
                </svg>
            </v-btn>
          </v-badge>
        </template>
        <span>{{ $t('history') }}</span>
      </v-tooltip>
    </div>
    <v-dialog
      v-model="contentDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-row class="mx-0 pt-1">
          <v-col
            class="pb-1"
            cols="12"
            md="6"
          >
            <v-btn
              icon
              class="close-hover"
              @click="contentDialog = false"
            >
              <v-icon
                color="grey"
                large
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="d-flex justify-end pb-1"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-shortkey="['f5']"
                  v-bind="attrs"
                  icon
                  class="mt-1"
                  @shortkey="getItems"
                  v-on="on"
                  @click="getItems"
                >
                  <v-icon
                    color="blue"
                    style="font-size: 22px"
                  >
                    mdi-refresh
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('refresh') }}(f5)</span>
            </v-tooltip>
            <v-chip-group
              v-model="selectMode"
              active-class="deep-purple--text text--accent-4"
              mandatory
            >
              <v-chip value="unread">
                {{ $t('showUnread') }}
              </v-chip>
              <v-chip value="read">
                {{ $t('showRead') }}
              </v-chip>
              <v-chip value="all">
                {{ $t('showAll') }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
        <v-row class="mx-0 mb-2">
          <v-col
            class="pt-0 px-2"
            cols="12"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              solo
              flat
              height="30"
              clearable
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              dense
            />
          </v-col>
        </v-row>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <v-data-table
            v-if="headers"
            v-model="selected"
            :height="350"
            fixed-header
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
            :page.sync="page"
            multi-sort
            dense
            :show-select="showSelect"
            item-key="id"
            class="mb-0"
            :footer-props="{
              showFirstLastPage: true,
              itemsPerPageOptions: [10, 25, 50, 100, 500],
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-plus',
              nextIcon: 'mdi-minus'
            }"
          >
            <template v-slot:item.user.name="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-if="item.user"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.user.firstname }}  {{ item.user.lastname }}
                  </div>
                </template>
                <span>{{ item.time }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.title="{ item }">
              {{item.title}}
              <v-btn
                v-if="item.reference_id"
                color="primary"
                icon
                small
                @click="link(item)"
              >
                <v-icon
                  color="primary"
                >
                  mdi-link-variant
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:item.seen="{ item }">
              <v-btn
                v-if="item.seen !== 'active'"
                color="primary"
                x-small
                outlined
                @click="setSeen(item)"
              >
                {{ $t('iRealized') }}
              </v-btn>
              <v-icon
                v-if="item.seen == 'active'"
                color="green"
              >
                mdi-check
              </v-icon>
            </template>
            <template v-slot:item.row="{ item }">
              {{ parseInt(items.indexOf(item))+ parseInt(from) }}
            </template>
            <template v-slot:item.time="{ item }">
              {{ item.time }}
            </template>
            <template v-slot:footer.prepend>
              <v-col
                v-show="!isMobile"
                cols="1"
                class="pa-0"
                style="margin-top: -10px"
              >
                <v-text-field
                  v-model.number="page"
                  :label="$t('goToPage')"
                  min="1"
                  :max="pageCount"
                  type="number"
                  outlined
                  height="32"
                  hide-details
                  hide-spin-buttons
                  dense
                  :suffix="'  /  ' + pageCount"
                />
              </v-col>
            </template>
          </v-data-table>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col class="pb-0">
          <v-btn
            icon
            class="close-hover"
            @click="alertDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col class="pt-0">
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/alertDialog.jpg"
          />
        </v-col>
        <v-col
          class="mt-0"
        >
          <h2 class="mx-auto text-center font-weight-medium">
            {{ $t('you') }} {{ unnotifiedCount }} {{ $t('haveNotifications') }}
          </h2>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="12">
              <v-btn
                block
                color="primary"
                @click="showContentDialog"
              >
                {{ $t('showNotifications') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="notificationDialog"
      :fullscreen="true"
      :hide-overlay="true"
      width="400"
    >
      <v-card v-if="notificationItem">
        <v-col class="pb-0">
          <v-btn
            icon
            class="close-hover"
            @click="closeWindow"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col class="pt-0">
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/alertDialog.jpg"
          />
        </v-col>
        <v-col
          class="mt-0"
        >
          <h4 class="mx-auto font-weight-medium">
            {{ $t('title') }} : {{ notificationItem.title }}
          </h4>
        </v-col>
        <v-col
          class="mt-0"
        >
          <h5 class="mx-auto font-weight-medium">
            {{ $t('content') }} : {{ notificationItem.body }}
          </h5>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="12" />
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="alertDialog"
      :timeout="1000"
      top
      color="primary"
      right
    >
      {{ $t('you') }} {{ unnotifiedCount }} {{ $t('haveNotifications') }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="alertDialog = false"
        >
          {{$t('close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'IndexNotification',
  components: {
  },
  props: ['userProp', 'typeProp', 'refIdProp', 'modeProp'],
  data () {
    return {
      contentBadge: 0,
      alertDialog: false,
      notificationDialog: false,
      showBadge: false,
      contentDialog: false,
      search: null,
      content: null,
      unnotifiedCount: 0,
      pageCount: 1,
      page: 1,
      items: [],
      selectMode: 'unread',
      refId: null,
      totalItems: null,
      type: null,
      notificationBrowser: null,
      selectedHeaders: null,
      selected: [],
      headers: null,
      timer: 0,
      loading: false,
      showSelect: false,
      notificationItem: null,
      user: null,
      options: {
        itemsPerPage: 10
      },
      product: null
    }
  },
  computed: {
    showHeaders () {
      var app = this
      return this.headers.filter(function (s) {
        if (app.typeForm === 'service') {
          if (s.value === 'stock' || s.value === 'order_point') {
          } else {
            return app.selectedHeaders.includes(s)
          }
        } else {
          return app.selectedHeaders.includes(s)
        }
      })
    },
    excelItems: function () {
      var app = this
      var list = []
      this.items.map((d, index) => {
        list.push({
          title: app.$t(d.title),
          content: app.$t(d.content)
        })
      })
      return list
    }
  },
  watch: {
    selectMode (val) {
      this.getUnreadNotifications()
      this.getItems()
    },
    contentBadge (val) {
      if (val && val > 0) {
        this.showBadge = true
      } else {
        this.showBadge = false
      }
    },
    userProp (val) {
      this.user = val
    },
    refIdProp (val) {
      this.refId = val
    },
    typeProp (val) {
      this.type = val
    },
    invoiceProp (val) {
      if (this.invoiceProp && val.tax_payer) {
        this.content = JSON.parse(val.tax_payer.reponse)
      } else {
        this.content = null
      }
    },
    search () {
      var app = this
      app.loading = true
      app.page = 1
      clearTimeout(this.timer)
      this.timer = setTimeout(function () {
        app.getItems()
      }, 10000)
    },
    options: {
      handler () {
        var app = this
        app.sortBy = []
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex(h => h.value === value)
          app.sortBy.push(app.headers[index].table)
        })
        this.getItems()
      },
      deep: true
    },
    sortBy () {
      const index = this.headers.findIndex(h => h.value === this.sortBy)
      if (index > -1) {
        this.sortBy = this.headers[index].table
      }
    }
  },
  beforeMount () {
    this.headers = [
      {
        text: this.$t('row'),
        align: 'start',
        sortable: false,
        value: 'row',
        width: 50
      },
      {
        text: '#',
        sortable: false,
        value: 'ref_action',
        width: 50
      },
      {
        text: this.$t('title'),
        sortable: false,
        value: 'title',
        width: 400
      },
      {
        text: this.$t('content'),
        sortable: false,
        value: 'content',
        width: 300
      },
      {
        text: this.$t('seen'),
        sortable: false,
        value: 'seen',
        width: 100
      },
      {
        text: this.$t('time'),
        sortable: false,
        value: 'time',
        width: 100
      }
    ]
    this.selectedHeaders = this.headers
    if (this.$route.query.item) {
      this.notificationItem = JSON.parse(this.$route.query.item)
      this.notificationDialog = true
      this.setSeen(this.notificationItem)
    }
  },
  mounted () {
    this.type = this.typeProp
    this.refId = this.refIdProp
    this.user = this.userProp
    if (!this.$route.query.item) {
      this.getUnnotifiedCount()
      this.getUnreadNotifications()
      this.getItems()
      this.getUnnotified()
      // var app = this
      // this.accurateTimer(function () {
      //   app.getUnnotified()
      // })
    }
  },
  methods: {
    closeWindow () {
      window.open('', '_self', '')
      window.close()
    },
    showContentDialog () {
      this.alertDialog = false
      this.contentDialog = true
      // this.notifyMe()
    },
    openDialogButton () {
      this.type = this.typeProp
      this.refId = null
      this.user = null
      this.contentDialog = true
    },
    openDialog (id, type, user) {
      this.type = type
      this.refId = id
      this.user = user
      this.contentDialog = true
    },
    getUnreadNotifications () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'notifications', {
        params: {
          getUnreadNotifications: 'active'
        }
      })
        .then(res => {
          res = res.data
          app.contentBadge = res
          if (app.contentBadge > 0 && !app.contentDialog) {
            // app.alertDialog = true
          }
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    getUnnotifiedCount () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'notifications', {
        params: {
          getUnnotifiedCount: 'active'
        }
      })
        .then(res => {
          res = res.data
          app.unnotifiedCount = res
          if (app.unnotifiedCount > 0 && !app.contentDialog) {
            app.alertDialog = true
          }
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    getUnnotified () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'notifications', {
        params: {
          getUnnotified: 'active'
        }
      })
        .then(res => {
          res = res.data
          var data = null
          app.unnotifiedCount = res.unnotifiedCount
          app.contentBadge = res.unseenCount
          if (app.unnotifiedCount > 0) {
            app.alertDialog = true
          }
          if (res.data && res.data.length > 0) {
            app.getUnreadNotifications()
            res.data.map(function (value, index) {
              data = {
                title: value.title,
                body: value.content,
                notifications_users_id: value.notifications_users_id
              }
              app.notifyMe(data)
            })
          }
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    link (item) {
      if (item.reference_type === 'task') {
        this.$router.push({ name: 'taskEdit', params: { id: item.reference_id } })
      }
      var invoiceType = ['sell', 'presale', 'returnSell', 'purchase', 'returnPurchase']
      if (invoiceType.includes(item.reference_type)) {
        this.$router.push({ name: 'invoicePrint', params: { id: item.uid, tabName: item.reference_id } })
      }

      var checksType = ['recieveCheck', 'payCheck']
      if (checksType.includes(item.reference_type)) {
        this.$router.push({ name: this.type + 'Edit', params: { id: item.reference_id } })
      }

      this.contentDialog = false
    },
    getItems () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'notifications', {
        params: {
          search: app.search,
          page: app.options.page,
          options: app.options,
          selectMode: app.selectMode
        }
      })
        .then(res => {
          res = res.data
          app.items = res.data
          app.totalItems = res.total
          app.pageCount = res.last_page
          app.from = res.from
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    setSeen (item) {
      var app = this
      app.loading = true
      item.seen = 'active'
      if (app.contentBadge > 0) {
        app.contentBadge--
      }
      app.$axios.get(this.$endpoint + 'notifications', {
        params: {
          setSeen: 'active',
          id: item.notifications_users_id
        }
      })
        .then(res => {
          res = res.data
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    notifyMe (data) {
      var app = this
      var icon = 'https://abr.abriron.com/favicon.png'
      var body = (data.body ? data.body : ' ')
      var title = data.title
      if (!('Notification' in window)) {
        alert('This browser does not support desktop notification')
      } else if (Notification.permission === 'granted') {
        this.notificationBrowser = new Notification(title, { body, icon })
        this.notificationBrowser.addEventListener('click', function () {
          window.open(window.location.href + '?item=' + JSON.stringify(data), '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400')
          app.showContentDialog()
        })
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            title = this.$t('notificationEnable')
            this.notificationBrowser = new Notification(title, { body, icon })
          }
        })
      }
    },
    accurateTimer (fn, time = 60000) {
      let nextAt, timeout
      nextAt = new Date().getTime() + time
      const wrapper = () => {
        nextAt += time
        timeout = setTimeout(wrapper, nextAt - new Date().getTime())
        fn()
      }
      const cancel = () => clearTimeout(timeout)
      timeout = setTimeout(wrapper, nextAt - new Date().getTime())

      return { cancel }
    }
  }
}
</script>

<style scoped>
::v-deep .v-badge__badge {
  font-size: 9px !important;
  height: 15px !important;
  min-width: unset;
  width: auto;
  padding: 4px;
}
</style>
